import { useCallback, useMemo, useState } from 'react';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { Endpoints } from 'UI/constants/endpoints';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useStatus = ({ selectedStatus }) => {
  const [statusOptions, setStatusOptions] = useState([]);

  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const isSubStatusEnabled = checkIfFeatureFlagEnabled(FeatureFlags.HaNameSubStatusEdition);

  const statusEndpoint = `${Endpoints.HiringAuthoritiesStatuses}?selectable=true`;
  const subStatusEndpoint =
    isSubStatusEnabled && selectedStatus?.id
      ? `${Endpoints.HiringAuthoritySubStatuses}?statusId=${selectedStatus.id}`
      : null;

  const selectedStatusValue = useMemo(() => {
    if (!selectedStatus || typeof selectedStatus === 'object') return selectedStatus;

    return statusOptions.find(option => option.id === selectedStatus) || null;
  }, [selectedStatus, statusOptions]);

  const handleStatusOptionsLoaded = useCallback(options => {
    setStatusOptions(options || []);
  }, []);

  const availableStatusOptions = useMemo(() => {
    if (!selectedStatusValue) return statusOptions;

    const hasSelectedStatus = statusOptions.some(option => option.id === selectedStatusValue.id);

    return hasSelectedStatus ? statusOptions : [selectedStatusValue, ...statusOptions];
  }, [selectedStatusValue, statusOptions]);

  return {
    availableStatusOptions,
    handleStatusOptionsLoaded,
    isSubStatusEnabled,
    selectedStatusValue,
    statusEndpoint,
    subStatusEndpoint
  };
};
